import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Users, ArrowRight } from "lucide-react";

export const TEAM_TIERS = [
  { seats: 5, price: 700 },
  { seats: 10, price: 1300 },
  { seats: 15, price: 1875 },
  { seats: 20, price: 2400 },
  { seats: 25, price: 2875 },
];
const BASE = 170;
const usd = (n) => `$${n.toLocaleString("en-US")}`;

export const TeamPricingDialog = ({ open, onOpenChange, onBuy }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl bg-white w-[calc(100vw-1.5rem)] p-5 sm:p-6" data-testid="team-pricing-dialog">
      <div className="text-[11px] font-semibold uppercase tracking-[0.22em] text-nm-coral flex items-center gap-2"><Users size={14} /> Team licenses</div>
      <DialogTitle className="font-serif text-3xl text-nm-ink font-normal">Get your whole team the full system</DialogTitle>
      <DialogDescription className="text-sm text-nm-neutral leading-relaxed">
        Each license is full access to all three toolkits. One is yours, and you can add teammates by email any time from your My Team page. Each person gets their own login.
      </DialogDescription>
      <div className="mt-2 overflow-x-auto rounded-xl border border-nm-ink/10">
        <table className="w-full text-sm">
          <thead><tr className="bg-nm-ink/[0.03] text-left text-[11px] uppercase tracking-[0.12em] text-nm-neutral">
            <th className="px-2.5 sm:px-4 py-3 font-semibold">Licenses</th><th className="px-2.5 sm:px-4 py-3 font-semibold">Price</th>
            <th className="hidden sm:table-cell px-2.5 sm:px-4 py-3 font-semibold">Per person</th><th className="px-2.5 sm:px-4 py-3 font-semibold">You save</th><th className="px-2.5 sm:px-4 py-3" /></tr></thead>
          <tbody>
            {TEAM_TIERS.map((t) => (
              <tr key={t.seats} className="border-t border-nm-ink/[0.06]" data-testid={`team-tier-${t.seats}`}>
                <td className="px-2.5 sm:px-4 py-3 font-medium text-nm-ink">{t.seats}</td>
                <td className="px-2.5 sm:px-4 py-3 font-serif text-lg text-nm-ink">{usd(t.price)}<span className="sm:hidden block whitespace-nowrap font-sans text-[11px] text-nm-neutral">{usd(t.price / t.seats)} each</span></td>
                <td className="hidden sm:table-cell px-2.5 sm:px-4 py-3 text-nm-neutral">{usd(t.price / t.seats)}</td>
                <td className="px-2.5 sm:px-4 py-3 text-nm-green font-medium">{usd(BASE * t.seats - t.price)}</td>
                <td className="px-2.5 sm:px-4 py-3 text-right">
                  <button type="button" onClick={() => onBuy(`team_${t.seats}`)} data-testid={`team-buy-${t.seats}`}
                    className="inline-flex items-center gap-1.5 rounded-full bg-nm-coral px-4 py-2 text-xs font-semibold text-white hover:brightness-105 transition-[filter] duration-200">
                    Buy <ArrowRight size={13} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-[12px] text-nm-neutral">One-time purchase. Need more than 25? Email <a href="mailto:hello@managemeantexcellence.com" className="text-nm-primary underline underline-offset-2">hello@managemeantexcellence.com</a>.</p>
    </DialogContent>
  </Dialog>
);
